module.exports = __webpack_public_path__ + "img/logo-circle.fc6d0afc.png";